// Auto-generated cornerstone translation for da.
// Source: cornerstones/nl.js, translated via Claude Sonnet on 2026-05-28T13:38:36.092065+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "Hestefodring app: bedste valg til 2026 | EquiSight",
      description: "Sammenlign hesteadministration apps til ejer, stald og avl. Opdag hvorfor EquiSight er den komplette app til din hest.",
      keywords: [
        "hesteadministration app",
        "staldstyring app",
        "heste logbog app",
        "app til at administrere flere heste",
        "hoppe drægtighed app",
        "avl app heste",
        "bedste hesteadministration app",
      ],
    },
    hero: {
      eyebrow: "Valgguide · hesteadministration software",
      breadcrumbLabel: "Hesteadministration app",
      title: "Hesteadministration app: den komplette valgguide til ejere, stalde og avlere.",
      intro: "Ikke bare en liste over funktioner — en ærlig sammenligning, en valgguide og et blik på hvad en hesteadministration app virkelig skal kunne i 2026. Til én hest, til en hel stald, eller til dit avlsarbejde.",
      pills: [
        {
          icon: "Users",
          label: "Til ejere",
        },
        {
          icon: "Building2",
          label: "Til stalde",
        },
        {
          icon: "Baby",
          label: "Til avlere",
        },
        {
          icon: "Share2",
          label: "Til teams",
        },
      ],
      ctas: [
        {
          label: "Start gratis med 1 hest",
          href: "#start",
          primary: true,
        },
        {
          label: "Gå til sammenligningsoversigt",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Hvorfor en hesteadministration app bliver stadig vigtigere.",
      lead: "Hesteadministration er i praksis spredt ud: WhatsApp, kalender, Excel, fotos på telefonen, et papirpas, løse fakturaer og mundtlige aftaler. Allerede besværligt med én hest. Med flere heste, avl eller delt pleje opstår der huller, mistede aftaler og diskussioner.",
      items: [
        "Hvornår var vaccinationsdatoen egentlig?",
        "Hvem betalte hovsmeden?",
        "Hvilken hoppe skal tjekkes i dag?",
        "Har træneren læst instruksen fra sidste uge?",
        "Har jeg virkelig gemt det fotodokument?",
        "Passer foderskemaet der hænger i stalden stadig?",
      ],
    },
    what: {
      title: "Hvad er en hesteadministration app?",
      lead: "En hesteadministration app er i bund og grund et digitalt dossier per hest. Ingen spredte noter, men ét sted til sundhed, træning, fodring, dokumenter, planlægning, påmindelser, udgifter, fotos, videoer og delt adgang. Alle omkring hesten ser den samme, opdaterede information.",
      targetGroupsTitle: "Hvem er en hesteadministration app beregnet til?",
      targetGroups: [
        {
          icon: "Heart",
          title: "Privat ejer",
          body: "Én hest, ét dossier — sundhed, planlægning og historik i lommen.",
        },
        {
          icon: "Users",
          title: "Ejer med flere heste",
          body: "Separate profiler, separat planlægning, delt opgaveliste til hele teamet.",
        },
        {
          icon: "Building2",
          title: "Pensionsstald og rideskole",
          body: "Ejeradgang, plejeinstruktioner, delt kalender og opgaver.",
        },
        {
          icon: "Baby",
          title: "Avl",
          body: "Hoppecyklus, drægtighed, hingstedata, stamtræ og føludvikling.",
        },
        {
          icon: "Target",
          title: "Trænere",
          body: "Overblik per hest, log sessioner, sæt mål, analysér videoer.",
        },
        {
          icon: "ClipboardList",
          title: "Fagfolk",
          body: "Hovsmed, tandlæge, fysioterapeut eller dyrlæge — arbejder fra det samme dossier.",
        },
      ],
    },
    criteria: {
      title: "Hvad skal en god hesteadministration app kunne?",
      lead: "En app er ikke kun flot — den skal fungere praktisk i hverdagen. Fem elementer der ikke må mangle i valget for 2026.",
      items: [
        {
          icon: "FileText",
          title: "Hestedossier per hest",
          body: "Data, alder, race, pasinformation, ejer, stald, fotos og dokumenter — alt koblet til én hesteprofil.",
        },
        {
          icon: "Heart",
          title: "Sundhed og pleje",
          body: "Vaccinationer, ormekur, hovsmed, tandlæge, dyrlæge, behandlinger, medicin og automatiske påmindelser før udløbsdatoen.",
        },
        {
          icon: "Activity",
          title: "Træning og fremskridt",
          body: "Log træninger, noter, videoer, konkurrenceresultater, mål og fremskridt per disciplin eller per hest.",
        },
        {
          icon: "Apple",
          title: "Fodring og management",
          body: "Foderskemaer, tilskud, grovfoder, vægt, kropskonditionen og den daglige rutine stalden skal kende.",
        },
        {
          icon: "Share2",
          title: "Del med andre",
          body: "Adgang til ejer, plejer, træner, staldbestyrer eller fagperson — med rettighedsstyring der passer til den enkeltes rolle.",
        },
        {
          icon: "Calendar",
          title: "Planlægning og påmindelser",
          body: "En delt kalender med opgaver, automatiske påmindelser og bekræftelse så intet glider igennem.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs. andre hesteadministration apps.",
      lead: "Det danske marked dækkes i øjeblikket af Stalmanager, LogMyHorse, EquineM og Happie Horse. De har hver deres styrker. Vi sammenligner de mest efterspurgte funktioner side om side — ærligt og baseret på offentligt tilgængelig information.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "Start gratis",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "Flere heste",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Sundhedsdossier",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Træning og fremskridt",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Fodring og tilskud",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Planlægning og påmindelser",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dokumenter per hest",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Del med team og rettigheder",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Avlsmodul (komplet)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Hoppecyklus",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Drægtighetsplanlægning + skanninger",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Følsudvikling",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Integration af fagfolk",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "EquiCoach indsigter",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Egnet til ejer",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Egnet til avl",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Egnet til stald/rideskole",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Sammenligning baseret på offentligt tilgængelige funktioner i januar 2026. Konkurrenterne er også gode værktøjer; EquiSight er bygget til at samle alle moduler i én app.",
    },
    why: {
      title: "Hvorfor EquiSight er anderledes.",
      lead: "En logbog registrerer. EquiSight kombinerer hesteadministration, træning, fodring, sundhed, konkurrencer, fagfolk og avl i én moderne app — og går et skridt videre med indsigter.",
      points: [
        {
          icon: "Heart",
          title: "Én app til hele hestens liv",
          body: "Fra føl til sportshest, avlshoppe eller pensionshest. Dossieret vokser med din hest — intet forsvinder undervejs.",
        },
        {
          icon: "Sparkles",
          title: "Ikke kun data, men også mønstre",
          body: "EquiCoach kombinerer udvikling, tilbagevendende klager, træning og fodring — så du opdager signaler i tide, ikke løse meldinger.",
        },
        {
          icon: "Share2",
          title: "Bygget til samarbejde",
          body: "Ejer, staldbestyrer, træner, hovsmed og andre fagfolk arbejder fra det samme hestedossier — med de rettigheder der passer til deres rolle.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Niche · avl",
      title: "Hesteadministration til avlere.",
      lead: "Mange konkurrenter nævner avl på én linje. EquiSight har bygget et komplet avlsmodul — fordi avleren sjældent er slutbrugeren af en generel app, men har mere brug for planlægning end nogen anden.",
      items: [
        "Følg hoppecyklus dagligt",
        "Inseminationsdato + hingstedata",
        "Drægtigheds­kontrol med skanninger",
        "Forventet føldato + advarsler",
        "Følsudvikling per måned",
        "Stamtræ og afstamning",
        "Noter per hoppe",
        "Oversigt over alle drægtige hopper",
      ],
      ctaLabel: "Se avlsmodulet",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Niche · stald og rideskole",
      title: "Hesteadministration til flere heste og pensionsstalde.",
      lead: "Med flere heste handler det mindre om data og mere om kommunikation. Hver ejer har egne ønsker, rutiner, fodringsaftaler og medicinske opmærksomhedspunkter. Hver medarbejder skal kunne tilgå det uden at lede.",
      cards: [
        {
          t: "Heste per ejer",
          d: "Hver ejer ser kun sine egne hest(e).",
        },
        {
          t: "Plejeinstruktioner",
          d: "Synlige per hest for stalden.",
        },
        {
          t: "Delt kalender",
          d: "Hovsmed, dyrlæge og konkurrencer i ét overblik.",
        },
        {
          t: "Opgaveliste",
          d: "Tildel til medarbejdere med bekræftelse.",
        },
        {
          t: "Ejeradgang",
          d: "Kunder ser deres hest i egen app.",
        },
        {
          t: "Nødkontakter",
          d: "Altid tilgængeligt i stressede situationer i stalden.",
        },
      ],
      ctaLabel: "Se rideskolemodulet",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "Fra WhatsApp, Excel og whiteboard til EquiSight.",
      lead: "Konkret: sådan ændrer din daglige hesteadministration sig.",
      rows: [
        {
          before: "WhatsApp-grupper",
          after: "Strukturerede noter per hest",
        },
        {
          before: "Excel-ark",
          after: "Live hestedossier med historik",
        },
        {
          before: "Whiteboard i stalden",
          after: "Delt planlægning på din telefon",
        },
        {
          before: "Løse fotos på kameraet",
          after: "Medier koblet til din hest",
        },
        {
          before: "Mundtlige aftaler",
          after: "Opgaver og påmindelser med bekræftelse",
        },
        {
          before: "Papirpas der forsvinder",
          after: "Dokumenter altid ved hånden",
        },
      ],
    },
    helper: {
      title: "Hvilken hesteadministration app passer til dig?",
      lead: "Besvar disse 5 spørgsmål og få en ærlig anbefaling — selv hvis den ikke altid er EquiSight.",
      questions: [
        {
          id: "horses",
          q: "Har du én hest eller flere heste?",
          options: [
            {
              label: "Én hest",
              score: 1,
            },
            {
              label: "2–5 heste",
              score: 2,
            },
            {
              label: "Mere end 5 heste",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "Administrerer du heste for kunder eller tredjepart?",
          options: [
            {
              label: "Nej, kun mine egne heste",
              score: 0,
            },
            {
              label: "Sommetider — for familie eller bekendte",
              score: 1,
            },
            {
              label: "Ja, professionelt (stald / rideskole)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "Vil du holde styr på avl og drægtighed?",
          options: [
            {
              label: "Ikke relevant",
              score: 0,
            },
            {
              label: "Sommetider — lejlighedsvis avl",
              score: 1,
            },
            {
              label: "Ja, jeg er (eller bliver) avler",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "Samarbejder du med træner, plejer eller fagperson?",
          options: [
            {
              label: "Nej, jeg gør det hele selv",
              score: 0,
            },
            {
              label: "Ja, med 1 person",
              score: 1,
            },
            {
              label: "Ja, med flere personer",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Vil du kun registrere eller også få indsigter?",
          options: [
            {
              label: "Kun registrere",
              score: 1,
            },
            {
              label: "Registrere + planlægning",
              score: 2,
            },
            {
              label: "Registrere + planlægning + indsigter",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "En simpel logbog er nok — og vokser med dig.",
          body: "Til én hest uden delt pleje er enhver hesteadministration app egnet. EquiSight starter gratis med 1 hest, så du risikerer intet. Hvis du senere vil tilføje flere heste, en træner eller avl, er alt allerede på plads.",
          cta: "Start gratis med 1 hest",
        },
        mid: {
          title: "EquiSight passer godt til din situation.",
          body: "Du har flere behov (flere heste, samarbejde eller indsigter). De fleste konkurrenter dækker 1-2 moduler; EquiSight kombinerer dem i én app uden at du skal koble løse værktøjer.",
          cta: "Se hvad EquiSight kan",
        },
        high: {
          title: "EquiSight er det mest oplagte valg.",
          body: "Din situation kombinerer flere heste, samarbejde, avl og/eller indsigter. Det er præcis her EquiSight gør forskellen — ingen spredte værktøjer, men ét hestedossier til alt og alle omkring hesten.",
          cta: "Start gratis med EquiSight",
        },
      },
    },
    faqTitle: "Ofte stillede spørgsmål om hesteadministration apps",
    faq: [
      {
        q: "Hvad er den bedste hesteadministration app?",
        a: "Den bedste hesteadministration app afhænger af din situation. Til blot en simpel logbog er flere apps egnede. Vil du kombinere sundhed, træning, fodring, dokumenter, avl, planlægning og samarbejde, er EquiSight bygget som en komplet løsning hvor alt samles i ét dossier.",
      },
      {
        q: "Kan jeg administrere flere heste i én app?",
        a: "Ja. En god hesteadministration app skal understøtte flere heste, herunder ejere, plejere, rutiner, dokumenter, aftaler og påmindelser per hest. EquiSight er designet til dette fra første linje kode — heste er individuelle dossiers, ikke rækker på en liste.",
      },
      {
        q: "Er EquiSight også egnet til avlere?",
        a: "Ja. EquiSight kan konfigureres med avlsfunktioner som hoppecyklus, inseminationsdato, drægtigheds­kontrol, hingstedata, stamtræ, forventet føldato og følsudvikling. Det er præcis det område, de fleste konkurrerende apps slet ikke eller kun i meget begrænset omfang dækker.",
      },
      {
        q: "Kan jeg dele data med min træner eller hovsmed?",
        a: "Ja. Formålet med EquiSight er at relevant information kan deles sikkert med personer omkring hesten — træner, hovsmed, tandlæge, dyrlæge, fysioterapeut, plejer eller ejer. Hver person får kun de rettigheder der er nødvendige for deres rolle.",
      },
      {
        q: "Hvorfor ikke bare bruge WhatsApp eller Excel?",
        a: "WhatsApp og Excel fungerer så længe det er enkelt. Når du har flere heste, aftaler, dokumenter, behandlinger, ejere eller avlsdata, bliver det fejlprone: information spreder sig, det tager tid at søge tilbage og mundtlige aftaler forsvinder. En hesteadministration app samler alt per hest med automatiske påmindelser.",
      },
      {
        q: "Hvad koster EquiSight?",
        a: "Du kan starte gratis med 1 hest. Vil du administrere flere heste, aktivere avl eller give fagfolk adgang, findes der overkommelige Premium-planer. Se de aktuelle muligheder på prissiden.",
      },
    ],
  },
  fokkerij: {
    seo: {
      title: "Avlssoftware hest: komplet sammenligning 2026",
      description: "Sammenlign avlssoftware til heste: hoppeens cyklus, drægtighedsstatus, hingstevalg og føl. Oplev hvorfor EquiSight er den komplette avlsapp.",
      keywords: [
        "avlssoftware hest",
        "hoppecyklus app",
        "hoppe drægtighedsapp",
        "følregistrering app",
        "stambogsapp hest",
        "paringsplanlægning hest",
        "hingstevalg app",
      ],
    },
    hero: {
      eyebrow: "Valgguide · avlssoftware",
      breadcrumbLabel: "Avlssoftware",
      title: "Avlssoftware til heste: den komplette sammenligning for 2026.",
      intro: "En avlshoppe fortjener mere end en generel heststyring-app. Sammenlign avlsfunktionerne i de mest kendte værktøjer, find ud af hvad du virkelig skal kigge efter, og vælg bevidst den software der passer til dit stutteri — stort eller lille.",
      pills: [
        {
          icon: "Baby",
          label: "Hoppecyklus",
        },
        {
          icon: "Heart",
          label: "Drægtighedskontrol",
        },
        {
          icon: "Sparkles",
          label: "Følудvikling",
        },
        {
          icon: "FileText",
          label: "Stambog",
        },
      ],
      ctas: [
        {
          label: "Start gratis med avlsmodulet",
          href: "#start",
          primary: true,
        },
        {
          label: "Til sammenligingstabellen",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Hvorfor en almindelig heststyring-app ikke er nok til avlsarbejde.",
      lead: "De fleste hestsport-apps er designet til én sports- eller fritidshest. Avlsarbejde har en helt anden rytme: brunst, inseminering, drægtighedskontrol, scanninger, følkalender, stamtavle og salg. Ét Excel-ark går i kaos efter 2 sæsoner — og med flere hopper mister du overblikket.",
      items: [
        "Hvornår var Bonitas sidste cyklus egentlig?",
        "Hvilken hingst er planlagt til parring næste sæson?",
        "Er den 21-dages scanning allerede planlagt?",
        "Hvilke føl fra 2024 er allerede solgt?",
        "Hvor er stamtavlediagrammet op til morfar?",
        "Hvor er DNA-prøverne og pasoplysningerne?",
      ],
    },
    what: {
      title: "Hvad er avlssoftware til heste?",
      lead: "Avlssoftware er en specialiseret journal for hver hoppe og hingst, kombineret med en avlssæsonkalender, drægtighedsplanlægning, følregistrering og stamtavlevisning. Ikke en generel hestejournal, men et værktøj der forstår avlscyklussen: fra første brunst til fravænning.",
      targetGroupsTitle: "Hvilken type avler er avlssoftware beregnet til?",
      targetGroups: [
        {
          icon: "Baby",
          title: "Hobbyavler (1-3 hopper)",
          body: "En eller to parringer om året — overblik uden Excel-akrobatik.",
        },
        {
          icon: "Building2",
          title: "Lille stutteri (4-10 hopper)",
          body: "En avlssæsonplan med cyklus, inseminering, drægtighedskontroller og føljournal.",
        },
        {
          icon: "Users",
          title: "Professionelt stutteri (10+)",
          body: "Flere medarbejdere, hingstevalg per hoppe, salg og markedsføring.",
        },
        {
          icon: "Target",
          title: "Hingstejer",
          body: "Bestillingshistorik, sæmenstatistikker og kalender per hingst.",
        },
        {
          icon: "Heart",
          title: "Embryotransplantation",
          body: "Donor + modtagerhoppe som sammenkoblet journal, ET-kalender.",
        },
        {
          icon: "ClipboardList",
          title: "Stambogsregistrering",
          body: "DNA-prøver, pasdokumenter og stamtavleoplysninger.",
        },
      ],
    },
    criteria: {
      title: "Hvad skal god avlssoftware kunne?",
      lead: "Ikke alle 'avlsfunktioner' i en hesteapp er ens. Fem kerneområder hvor avlere mister meget tid — og hvor software virkelig gør en forskel.",
      items: [
        {
          icon: "Calendar",
          title: "Hoppecyklus & brunst",
          body: "Daglig log, forudsigelse af ægløsning, fremskrivning per cyklus og automatiske påmindelser.",
        },
        {
          icon: "Heart",
          title: "Inseminering & drægtighedskontrol",
          body: "Parings- og insemineringsdato, hingsteoplysninger, 14-dages scanning, 21-dages scanning, 60-dages scanning og kønsfastlæggelse.",
        },
        {
          icon: "Baby",
          title: "Følудvikling",
          body: "Fødselsoplysninger, vægtgrafik, ormekurplan, fravænningsmoment, pasregistrering.",
        },
        {
          icon: "FileText",
          title: "Stamtavle & papirer",
          body: "Stamtavlevisning op til 4-5 generationer, DNA, pasnumre og stambogsstatus.",
        },
        {
          icon: "Target",
          title: "Hingstevalg & matching",
          body: "Filtrering på disciplin, linjer, hingsteoplysninger og historisk succes — ikke kun det en hingstejer promoverer.",
        },
        {
          icon: "Share2",
          title: "Samarbejde med dyrlæge/inseminator",
          body: "Scanninger, prøver og statusser delt direkte med den praksis der arbejder med dine hopper.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs. anden avlssoftware.",
      lead: "Søgeresultaterne for avlssoftware viser ofte generiske hesteapps der nævner avl i én sætning. Vi sammenligner ærligt hvilke værktøjer der virkelig har et komplet avlsflow.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Start gratis",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Log hoppecyklus",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Insemineringsdato + hingst",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Scanninger & drægtighedskontrol",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Forventet fødselsdato",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Føljournal (vægt/vækst)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Stamtavle op til 4-5 generationer",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "DNA & pasregistrering",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Hingstevalg / matching",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "ET / embryotransplantation",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Oversigt over flere hopper",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Mobil (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Del med dyrlæge",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integreret med generel journal",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Salg & markedsføring af føl",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Sammenligning baseret på offentligt tilgængelige funktioner i januar 2026. EquineGenie er stærk inden for avl, men knap så god på mobil + generel heststyring. EquiSight kombinerer begge dele.",
    },
    why: {
      title: "Hvorfor EquiSight betjener avlere anderledes.",
      lead: "Mange avlere arbejder med separat avlssoftware og en selvstændig heststyring-app. EquiSight kombinerer begge — uden at du skal skifte mellem apps eller indtaste data dobbelt.",
      points: [
        {
          icon: "Heart",
          title: "Avlshoppen er stadig en almindelig hest",
          body: "Avlshoppen har en avlssæsonjournal og en almindelig hestejournal — sundhed, vaccinationer, smed. Én app, alle moduler.",
        },
        {
          icon: "Sparkles",
          title: "Forudsigelse frem for reaktion",
          body: "Cyklusforudsigelse, drægtighedsmilepæl-påmindelser og følkalender — automatisk baseret på dine data.",
        },
        {
          icon: "Share2",
          title: "Alle omkring avlsarbejdet",
          body: "Inseminator, hingstejer, dyrlæge, køber, stambog — alle har adgang med de rette rettigheder.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Per disciplin · cyklus til fravænning",
      title: "Hvad en avlsjournal i EquiSight indeholder.",
      lead: "Hver hoppe får en komplet avlsjournal, koblet til hendes almindelige hestejournal.",
      items: [
        "Daglig cykluslog med forudsigelse",
        "Inseminering/parring + hingsteoplysninger",
        "Scanning-tidslinje (14/21/60 dage + køn)",
        "Drægtighedsmilepæle med automatiske påmindelser",
        "Forventet fødselsdato og forberedelse",
        "Føljournal fra fødslen",
        "Stamtavle til bedsteforældre med klik-navigation",
        "DNA-prøve, pas, stambogsstatus",
        "Salgspipeline med interesserede",
        "Hingstevalgshistorik per hoppe",
      ],
      ctaLabel: "Se avlsmodulet",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "For hele stutteriet",
      title: "Overblik over flere hopper og hingste.",
      lead: "Når du avler med mere end 2-3 hopper, bliver overblikket over alle cyklusser og drægtighedsforløb afgørende.",
      cards: [
        {
          t: "Cyklus-dashboard",
          d: "Alle hopper side om side, med cyklusstadium og næste handling.",
        },
        {
          t: "Drægtighedspipeline",
          d: "Hvilke hopper er hvor i drægtighedsmilepælene?",
        },
        {
          t: "Følkalender",
          d: "Forventede fødsler per måned, med logistik tilpasset hertil.",
        },
        {
          t: "Hingsteportefølje",
          d: "Egne hingste eller faste inseминatorer med bestillingshistorik.",
        },
        {
          t: "Stamtavlegrafik",
          d: "Forfaderanalyse over flere generationer og linjer.",
        },
        {
          t: "Salgsdashboard",
          d: "Hvilke føl er solgt, reserveret eller stadig tilgængelige.",
        },
      ],
    },
    beforeAfter: {
      title: "Fra Excel + kalender til EquiSight avlsmodul.",
      lead: "Konkret: sådan ændrer dit avlssæson sig.",
      rows: [
        {
          before: "Cyklus i løs notits",
          after: "Daglig log med forudsigelse",
        },
        {
          before: "Scanninger via WhatsApp til inseminator",
          after: "Delt journal med fotos",
        },
        {
          before: "Drægtighedsdato i kalender",
          after: "Automatiske milepælspåmindelser",
        },
        {
          before: "Følpas i skuffen",
          after: "Dokument koblet til følprofil",
        },
        {
          before: "Stamtavle på papir",
          after: "Klikbar stamtavle op til 4-5 generationer",
        },
        {
          before: "Salgsannonce på Marktplaats",
          after: "Salgspipeline med interesseliste",
        },
      ],
    },
    helper: {
      title: "Hvilken avlssoftware passer til dig?",
      lead: "5 spørgsmål til at finde ud af om du har brug for en komplet avlsapp eller om et hobbyværktøj er nok.",
      questions: [
        {
          id: "mares",
          q: "Hvor mange avlshopper styrer du?",
          options: [
            {
              label: "1 hoppe",
              score: 1,
            },
            {
              label: "2-5 hopper",
              score: 2,
            },
            {
              label: "Mere end 5 hopper",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "Hvor ofte avler du per år?",
          options: [
            {
              label: "Lejlighedsvis (hvert par år)",
              score: 0,
            },
            {
              label: "Hvert år 1-2 parringer",
              score: 2,
            },
            {
              label: "Hvert år 3+ parringer",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "Hvordan inseminerer/parer du?",
          options: [
            {
              label: "Naturlig bedækning",
              score: 1,
            },
            {
              label: "AI frisk/nedkølet sæd",
              score: 2,
            },
            {
              label: "ET eller frosset sæd",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "Samarbejder du med dyrlæge/inseminator?",
          options: [
            {
              label: "Én fast person",
              score: 1,
            },
            {
              label: "Flere klinikker",
              score: 2,
            },
            {
              label: "Internationalt netværk",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "Hvad registrerer du i dag?",
          options: [
            {
              label: "Excel eller papir",
              score: 1,
            },
            {
              label: "Generel heststyring-app",
              score: 2,
            },
            {
              label: "Intet struktureret",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Et hobbyværktøj eller Excel er nok — men EquiSight er stadig praktisk.",
          body: "For 1 hoppe med naturlig bedækning hvert par år er et avanceret avlsmodul overkill. EquiSight starter gratis, og du aktiverer avlsmodulet kun det år du avler — uden opgraderingskrav.",
          cta: "Start gratis",
        },
        mid: {
          title: "EquiSight avlsmodul er det rigtige valg.",
          body: "Du har flere hopper eller flere avlsmetoder — det er generelle hesteapps ikke bygget til. EquiSight kombinerer avl + generel pleje, så du ikke skal skifte mellem to værktøjer.",
          cta: "Se avlsmodulet",
        },
        high: {
          title: "EquiSight er bygget til dit stutteri.",
          body: "Flere hopper, ET eller frosset sæd, internationalt team — de fleste værktøjer kommer til kort her. EquiSight skalerer op til stutteriniveau uden at du skal stable ekstra licenser.",
          cta: "Tal med os om en stutteriplan",
        },
      },
    },
    faqTitle: "Ofte stillede spørgsmål om avlssoftware",
    faq: [
      {
        q: "Hvad er den bedste avlssoftware til heste?",
        a: "For 1 hoppe uden kompliceret avlsmetode er mange værktøjer tilstrækkelige. Fra 2-3 hopper, brug af AI eller ET, eller samarbejde med dyrlæge og stambog, bliver et komplet avlsmodul afgørende. EquiSight kombinerer avl med generel heststyring i én app, så du ikke behøver at skifte.",
      },
      {
        q: "Hvilke avlsfunktioner har jeg virkelig brug for?",
        a: "Minimum: cykluslog, insaminerings-/paringsoplysninger, drægtighedsmilepæle og føljournal. Valgfrit men stærkt: stamtavlevisning, hingstevalgsarkiv, DNA/pas og salgspipeline.",
      },
      {
        q: "Kan EquiSight forudsige en hoppes cyklus?",
        a: "Ja. EquiSight bruger tidligere cyklusdata til at vise den forventede ægløsning, så du kan planlægge inseminering eller parring på det rette tidspunkt — uden daglig gætteleg.",
      },
      {
        q: "Virker EquiSight også til embryotransplantation?",
        a: "Ja. Donor- og modtagerhoppe får sammenkoblede journaler, ET-kalender og delte milepæle med klinikken. Så mister du ikke overblikket i det komplekse ET-forløb.",
      },
      {
        q: "Kan jeg importere mine eksisterende avlsdata?",
        a: "Du kan indtaste cyklus, parringer og føldata manuelt eller samlet via CSV. Ved aktive stutterier hjælper vi med en engangsmigrering, hvis du har data fra flere sæsoner.",
      },
      {
        q: "Hvordan deler jeg journalen med min dyrlæge eller inseminator?",
        a: "Hver person får adgang med en rolle: dyrlæge, inseminator, hingstejer eller stambogsfunktionær. Alle ser kun de oplysninger der er nødvendige for deres rolle — ingen fuld adgang kræves.",
      },
    ],
  },
  manege: {
    seo: {
      title: "Rideskole software: komplet sammenligning & valguide 2026",
      description: "Sammenlign rideskole software til undervisning, ryttere, heste og administration. Find den app der passer til din rideskole eller pensionstal.",
      keywords: [
        "rideskole software",
        "stalmanagement app",
        "rideskole administrationssoftware",
        "undervisningsplanlægning rideskole",
        "pensionstal software",
        "rytteradministration",
        "hesteadministration rideskole",
      ],
    },
    hero: {
      eyebrow: "Valguide · rideskole software",
      breadcrumbLabel: "Rideskole software",
      title: "Rideskole software: den komplette valguide til rideskoler og pensionstalде.",
      intro: "Undervisningsplanlægning, rytteradministration, hestestyring, fakturering og kommunikation — god rideskole software samler det hele. Sammenlign de mest kendte muligheder og find ud af, hvilken der passer til din stald eller rideskole.",
      pills: [
        {
          icon: "Calendar",
          label: "Undervisningsplanlægning",
        },
        {
          icon: "Users",
          label: "Ryttere & kunder",
        },
        {
          icon: "Heart",
          label: "Hestepleje",
        },
        {
          icon: "CreditCard",
          label: "Fakturering",
        },
      ],
      ctas: [
        {
          label: "Anmod om en demo",
          href: "#start",
          primary: true,
        },
        {
          label: "Se sammenligningstabell",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Hvorfor spredte værktøjer gør en rideskole langsom.",
      lead: "De fleste rideskoler kører på et lappetæppe: undervisningsplanlægning på en whiteboard, rytterregistrering i Excel, fakturering i et andet værktøj, hestepleje i WhatsApp og ejerhenvendelser via private beskeder. I en travl uge opstår der dobbeltbookinger, glemte fakturaer eller heste, der ikke ved hvilken rytter de får.",
      items: [
        "Hvem er til undervisning på Jasmin nu?",
        "Hvilken rytter har endnu ikke betalt for marts?",
        "Hvilken hest må ikke bruges denne uge?",
        "Hvem er nødkontakter for eleverne?",
        "Har ejeren af Stardust allerede modtaget smedefakturaen?",
        "Hvilken hest er i hvilken boks?",
      ],
    },
    what: {
      title: "Hvad er rideskole software?",
      lead: "Rideskole software kombinerer undervisningsplanlægning, rytteradministration, hestestyring, fakturering og kommunikation i ét værktøj. Ingen Excel-akrobatik eller WhatsApp-kaos, men ét sted hvor rideskolen arbejder og ejere/ryttere kan følge med.",
      targetGroupsTitle: "Hvilken type virksomhed er rideskole software beregnet til?",
      targetGroups: [
        {
          icon: "Building2",
          title: "Lille rideskole (1-15 heste)",
          body: "Primært undervisningsplanlægning og betalinger — administration uden besvær.",
        },
        {
          icon: "Users",
          title: "Mellemstor rideskole (15-40 heste)",
          body: "Flere instruktører, undervisningsplanlægning + hesteskema + rytteradministration.",
        },
        {
          icon: "ClipboardList",
          title: "Stor ride- og pensionstal (40+)",
          body: "Fuld drift inklusiv fakturering, foder- og smedelogistik.",
        },
        {
          icon: "Heart",
          title: "Pensionstal",
          body: "Ejerportal, individuelle plejeinstruktioner, delt kalender.",
        },
        {
          icon: "Target",
          title: "Springrytter træningstal",
          body: "Konkurrenceplanlægning, træning per hest, kundekontakt.",
        },
        {
          icon: "FileText",
          title: "Hippiske iværksættere",
          body: "Mix af undervisning + pension + klinik + handel — alt fra ét system.",
        },
      ],
    },
    criteria: {
      title: "Hvad skal god rideskole software kunne?",
      lead: "En flot app betyder intet, hvis dine medarbejdere ikke vil bruge den. Fem praktiske kriterier, der gør forskellen mellem succes og frustration.",
      items: [
        {
          icon: "Calendar",
          title: "Undervisningsplanlægning på flere niveauer",
          body: "Begynder/øvet, dressur/spring, heste-tildelinger og instruktørers kalendere — alle synlige side om side.",
        },
        {
          icon: "Users",
          title: "Rytteradministration",
          body: "Profiler, niveau, abonnement, undervisningskort og familieforbindelser for unge ryttere.",
        },
        {
          icon: "Heart",
          title: "Hesteskema",
          body: "Hvilken hest bruges hvor ofte, med hvile-, skade- og brunsttperioder.",
        },
        {
          icon: "CreditCard",
          title: "Fakturering & abonnementer",
          body: "Månedlige abonnementer, undervisningskort, enkeltlektioner og automatisk opkrævning.",
        },
        {
          icon: "Share2",
          title: "Ejerportal (pensionstal)",
          body: "Ejere ser deres hest i en egen app — kalender, udgifter, smed og noter uden opkald.",
        },
        {
          icon: "Bell",
          title: "Kommunikation & påmindelser",
          body: "Automatiske undervisningspåmindelser, betalingsnotifikationer, smedeoffentliggørelser — uden at sende beskeder manuelt.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs. anden rideskole software.",
      lead: "Mange rideskoleværktøjer er stærke i undervisningsplanlægning eller fakturering, men sjældent i hestepleje og ejerkommunikation på samme tid. Vi stiller dem op ærligt over for hinanden.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "Gratis start / prøveperiode",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Undervisningsplanlægning",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Flere instruktører",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Rytteradministration",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Hesteskema",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Hestepleje (vaccination/smed)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Undervisningskort / abonnement",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Online betalinger",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Automatisk fakturering",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Ejerportal (pension)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Smed/dyrlæge integration",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "WhatsApp/SMS påmindelser",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Mobil (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Konkurrenceplanlægning",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Egnet til pensionstal",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "Sammenligning baseret på offentligt tilgængelige funktioner i januar 2026. Stalmanager er stærk i administration, EquiSight skiller sig ud med pensionstal-flow + hestepleje + ejerportal.",
    },
    why: {
      title: "Hvorfor EquiSight er anderledes for rideskoler og pensionstalде.",
      lead: "EquiSight går længere end en undervisningsplanlægger. Vi ser en rideskole som en komplet drift: heste, mennesker, kommunikation og økonomi — alle afhængige af hinanden.",
      points: [
        {
          icon: "Heart",
          title: "Hesten i centrum, ikke kalenderen",
          body: "Hver hest har sin egen mappe. Undervisningsbrug, sundhed, smed og konkurrencer i én tidslinje — ikke 3 separate værktøjer.",
        },
        {
          icon: "Share2",
          title: "Ejere følger med uden opkald",
          body: "Pensionstal-ejere har deres egen visning: udgifter, planlægning, billeder og noter — sparer 5-10 telefonopkald om ugen.",
        },
        {
          icon: "Bell",
          title: "Automatisk kommunikation",
          body: "Undervisningspåmindelse, vaccinationspåmindelse, faktura — automatisk via app/e-mail/SMS. Ingen broadcast-WhatsApp mere.",
        },
      ],
    },
    nicheB: {
      eyebrow: "Til pensionstaldet",
      title: "Hvad et pensionstal får med EquiSight.",
      lead: "Pensionstalде har unikke udfordringer, som almindelig rideskolesoftware ikke løser.",
      cards: [
        {
          t: "Ejerportal",
          d: "Hver ejer ser kun sin/sine hest(e), kalender og udgifter.",
        },
        {
          t: "Plejeinstruktioner per hest",
          d: "Foder, grovfoder, tilskud, dækkenskema — synligt for stalden.",
        },
        {
          t: "Delt kalender",
          d: "Smed, dyrlæge og ejerbesøg i én visning.",
        },
        {
          t: "Forbrugsomkostninger per hest",
          d: "Strøelse, foder, kraftfoder viderefaktureret per ejer.",
        },
        {
          t: "Nødkontakter til hesten",
          d: "Ejer + dyrlæge + smed altid tilgængeligt for stalden.",
        },
        {
          t: "Afgræsningsstyring",
          d: "Hvilke heste går på fold, holder hvile eller er i revalidering?",
        },
      ],
    },
    beforeAfter: {
      title: "Fra whiteboard + Excel til EquiSight.",
      lead: "Konkret: sådan ændres en arbejdsuge på rideskolen.",
      rows: [
        {
          before: "Whiteboard med undervisningsplanlægning",
          after: "Live planlægning per instruktør",
        },
        {
          before: "Excel med ryttere + undervisningsnoter",
          after: "Kunde-CRM med undervisningshistorik",
        },
        {
          before: "WhatsApp til ejere",
          after: "Ejerportal til deres hest",
        },
        {
          before: "Månedlig opkrævning manuelt",
          after: "Automatisk fakturering + iDEAL",
        },
        {
          before: "Hestepleje på en papiropslagstavle",
          after: "Plejeinstruktioner per hest, delt",
        },
        {
          before: "Mundtlig aftale med smed",
          after: "Smedelogistik med bekræftelser",
        },
      ],
    },
    helper: {
      title: "Hvilken rideskole software passer til dig?",
      lead: "5 spørgsmål for at se om EquiSight er den rette platform til din rideskole eller pensionstal.",
      questions: [
        {
          id: "size",
          q: "Hvor mange heste har du i din virksomhed?",
          options: [
            {
              label: "Færre end 10",
              score: 1,
            },
            {
              label: "10-30",
              score: 2,
            },
            {
              label: "Mere end 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "Hvad er din primære aktivitet?",
          options: [
            {
              label: "Primært undervisning",
              score: 1,
            },
            {
              label: "Pensionstal (heste i pension)",
              score: 3,
            },
            {
              label: "Mix af undervisning + pension",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "Hvor mange instruktører arbejder du med?",
          options: [
            {
              label: "Kun mig selv",
              score: 1,
            },
            {
              label: "2-3 instruktører",
              score: 2,
            },
            {
              label: "4 eller flere",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "Hvordan håndterer du din fakturering nu?",
          options: [
            {
              label: "Manuelt (Word/Excel)",
              score: 3,
            },
            {
              label: "Separat regnskabsprogram",
              score: 2,
            },
            {
              label: "Integreret i undervisningsværktøjet",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "Hvordan kommunikerer du med ejerne?",
          options: [
            {
              label: "Personligt / WhatsApp",
              score: 3,
            },
            {
              label: "E-mail + WhatsApp",
              score: 2,
            },
            {
              label: "Ejerportal i værktøjet",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Et enkelt værktøj eller Excel kan klare det foreløbigt — men EquiSight skalerer med dig.",
          body: "For en lille undervisningsvirksomhed med én instruktør og få pensionsheste er en avanceret løsning ikke nødvendig med det samme. EquiSight starter gratis og vokser med din rideskole — ingen migrationsproblemer om et par år.",
          cta: "Start gratis",
        },
        mid: {
          title: "EquiSight er en oplagt opgradering til din rideskole.",
          body: "Flere instruktører, en blanding af undervisning og pension, eller fakturering der i øjeblikket er adskilt — EquiSight samler det i én arbejdsgang. Særligt ejerportalen sparer meget ad-hoc kommunikation.",
          cta: "Anmod om en demo",
        },
        high: {
          title: "EquiSight er bygget til din skala.",
          body: "Pensionstal + undervisning + flere instruktører er præcis der, hvor EquiSight adskiller sig fra klassiske rideskoledværktøjer. Ejerportalen og hesteplejeinegrationen sparer ugentligt mange timers administration og kommunikation.",
          cta: "Planlæg en demo til din stald",
        },
      },
    },
    faqTitle: "Ofte stillede spørgsmål om rideskole software",
    faq: [
      {
        q: "Hvad er den bedste rideskole software?",
        a: "Til ren undervisningsplanlægning er der flere gode muligheder. Når du har brug for pensionstal, flere instruktører eller hestepleje-sporing, bliver EquiSight den komplette løsning — ingen jonglering med værktøjer, alt på ét sted.",
      },
      {
        q: "Kan jeg importere eksisterende kunder og lektioner?",
        a: "Ja. Kundedata og undervisningsskemaer kan importeres via CSV. Vi hjælper aktive rideskoler med en engangsmigration, så du ikke skal indtaste 200 ryttere manuelt.",
      },
      {
        q: "Virker det også til et pensionstal uden undervisning?",
        a: "Ja. Pensionstal-tilstand deaktiverer undervisning og fokuserer på ejerportal, foder/pleje, smedelogistik og viderefakturering af udgifter per hest.",
      },
      {
        q: "Kan ryttere selv tilmelde sig og betale?",
        a: "Ja. Ryttere kan via en egen konto se hvilke lektioner der er ledige, tilmelde sig, betale undervisningspenge med iDEAL og købe undervisningskort.",
      },
      {
        q: "Hvad med privatlivsbeskyttelse af heste- og ejerdata?",
        a: "Hver person har en rolle (ejer, rytter, instruktør, medarbejder). Per rolle ser du kun det, du har brug for. Ejere ser kun deres hest, ryttere kun deres egne lektioner.",
      },
      {
        q: "Kan EquiSight integrere med mit regnskabsprogram?",
        a: "Ja, integrationer med Exact, Moneybird og e-Boekhouden er tilgængelige. Fakturaer overføres da automatisk til dit regnskab.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "Træner app hest: sammenligning & valguide til coaches 2026",
      description: "Sammenlign træner apps til hest og rytter: træningslog, video, mål, protokolanalyse og klienthåndtering. Find det rigtige værktøj til coaches.",
      keywords: [
        "træner app hest",
        "instruktør app",
        "hest træning app",
        "rytter coaching app",
        "træningsdagbog hest",
        "dressurprotokol analysere",
        "hestetræner software",
      ],
    },
    hero: {
      eyebrow: "Valguide · træner software",
      breadcrumbLabel: "Træner app",
      title: "Træner app hest: komplet valguide til instruktører og coaches.",
      intro: "En træner eller instruktør jonglerer med kombinationer, lektioner, videoer, mål og stævner. Sammenlign de bedste træner apps til hestemensker og vælg den platform, der også i 2026 vokser med din coaching.",
      pills: [
        {
          icon: "Target",
          label: "Mål & planlægning",
        },
        {
          icon: "Video",
          label: "Videoanalyse",
        },
        {
          icon: "TrendingUp",
          label: "Fremskridt",
        },
        {
          icon: "Users",
          label: "Klienter/kombinationer",
        },
      ],
      ctas: [
        {
          label: "Start gratis som træner",
          href: "#start",
          primary: true,
        },
        {
          label: "Gå til sammenligningstavle",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Derfor hæmmer WhatsApp-coaching trænere.",
      lead: "De fleste trænere arbejder med løse værktøjer: WhatsApp til kommunikation, en notesbog til lektioner, YouTube eller WeTransfer til videoer og Excel til stævneresultater. Med 5 ryttere fungerer det. Med 20 ryttere går information tabt, du glemmer mål og mister overblikket over individuelle fremskridt.",
      items: [
        "Hvad er Anouks mål for denne sæson?",
        "Hvilken video sendte jeg til Bram sidste måned?",
        "Har Lara set protokolanalysen fra hendes seneste stævne?",
        "Hvilken kombination træner hvor mange gange om ugen?",
        "Har ejeren af Stardust læst mine træningsinstruktioner?",
        "Hvornår gav jeg sidst feedback på svingende impuls?",
      ],
    },
    what: {
      title: "Hvad er en træner app til hest og rytter?",
      lead: "En træner app kombinerer et coaching-CRM (kombinationer, lektioner, mål), en træningslog pr. hest, videofeedback, stævneplanlægning og protokolanalyse. Ikke mere løs WhatsApp/YouTube/Excel, men én platform, hvor træner og rytter arbejder sammen.",
      targetGroupsTitle: "Hvilken type træner er dette beregnet til?",
      targetGroups: [
        {
          icon: "Target",
          title: "Dressur­instruktør",
          body: "Scanne protokoller, koble dommerkommen­tarer til træningsmål, følge fremskridt.",
        },
        {
          icon: "Activity",
          title: "Springtræner",
          body: "Parcours­planlægning, runde­feedback, højde­styring pr. hest.",
        },
        {
          icon: "Award",
          title: "Eventing coach",
          body: "Tre discipliner, tre planlægninger – alle synlige side om side.",
        },
        {
          icon: "TrendingUp",
          title: "Performance coach (sport)",
          body: "EPI-tracking, stævner, mål — til eliteryttere og deres teams.",
        },
        {
          icon: "Users",
          title: "Rideskole­instruktør",
          body: "Gruppeundervisning + individuel coaching i én app.",
        },
        {
          icon: "Heart",
          title: "Rekreativ coach",
          body: "Hippisk terapi, begyndere, ejere med én hest.",
        },
      ],
    },
    criteria: {
      title: "Hvad skal en god træner app opfylde?",
      lead: "Træning er menneskearbejde, men det rigtige værktøj gør dig 30-50% mere effektiv og hjælper ryttere med at blive bedre også mellem lektionerne.",
      items: [
        {
          icon: "Users",
          title: "Kombinationsstyring",
          body: "Hest + rytter som én enhed med niveau, mål, fremskridt og historik.",
        },
        {
          icon: "ClipboardList",
          title: "Lektionsnoter & mål",
          body: "En note pr. lektion med fokuspunkter, koblet til langsigtede mål.",
        },
        {
          icon: "Video",
          title: "Videofeedback",
          body: "Upload video, tag øjeblikke, tilføj talt eller skrevet feedback.",
        },
        {
          icon: "Target",
          title: "Stævne & protokolanalyse",
          body: "Scan protokoller (KNHS/FEI), se scores pr. element, dommerkommentarer og tendenser.",
        },
        {
          icon: "Calendar",
          title: "Planlægning & lektionskort",
          body: "Kalender, betalinger, abonnementer og automatiske påmindelser.",
        },
        {
          icon: "Share2",
          title: "Kommunikation til rytter",
          body: "Rytteren ser sin egen side med lektioner, videoer, mål og feedback.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs andre træner apps.",
      lead: "Nogle trænerværktøjer fokuserer på at erstatte WhatsApp, andre på protokolanalyse. EquiSight kombinerer begge med et ægte heste­dossier — så rytteren også bliver bedre mellem lektionerne.",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "Start gratis",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Kombinationsstyring",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Lektionsnoter & feedback",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Langsigtede mål",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Video upload + feedback",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "KNHS/FEI protokolscanning",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (Performance Index)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Stævnekalender",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Rytter­portal",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Lektionskort / abonnement",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Online betalinger",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integreret heste­dossier",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Smed/dyrlæge synlig",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Til instruktør OG rytter",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Flere heste pr. rytter",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "Sammenligning baseret på offentligt tilgængelige funktioner i januar 2026. EquiSight er unik inden for protokolanalyse + EPI og kombinerer dette med generel hestestyring.",
    },
    why: {
      title: "Hvorfor EquiSight tilbyder en anderledes træneroplevelse.",
      lead: "De fleste trænerværktøjer stopper, hvor lektionen slutter. EquiSight fortsætter — i heste­dossieret, i stævneanalysen, i samarbejdet med dyrlæge og ejer.",
      points: [
        {
          icon: "TrendingUp",
          title: "Protokolscan → træningsmål",
          body: "Scan et KNHS-protokol og se straks, hvilke elementer der kræver opmærksomhed. Mål fremkommer automatisk.",
        },
        {
          icon: "Sparkles",
          title: "EquiCoach styrker dit øje",
          body: "Data fra flere lektioner, stævner og protokoller afslører mønstre, du ikke kan holde styr på i hovedet.",
        },
        {
          icon: "Share2",
          title: "Integreret med hesten",
          body: "Træneren ser vaccination, smed og skade­historik for hesten — ingen træning planlægges under restitution.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Til dressur og spring",
      title: "Hvad et coaching­dossier i EquiSight indeholder.",
      lead: "For hver kombination får du en coaching­strøm, der holder alt samlet — aldrig mere miste ting i WhatsApp.",
      items: [
        "Lektionsnoter med fokuspunkter pr. session",
        "Langsigtede mål + milepæle",
        "Video upload med tidskode­kommentarer",
        "KNHS/FEI protokolscan med scores",
        "Dommerkommentarer koblet til træning",
        "Stævneresultater og EPI-tendens",
        "Klientkontakt og lektionshistorik",
        "Lektionskort / abonnement / fakturaer",
        "Fremskridtsgraf pr. disciplin",
        "Delt adgang med hesteejer",
      ],
      ctaLabel: "Se træner­modulet",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "Fra WhatsApp + YouTube til EquiSight Trainer.",
      lead: "Konkret: sådan ændrer din coaching­workflow sig.",
      rows: [
        {
          before: "WhatsApp med løse videolinks",
          after: "Video med tidskode­feedback i dossier",
        },
        {
          before: "Notesbog pr. rytter",
          after: "Coaching­log med mål + historik",
        },
        {
          before: "Excel med stævnescores",
          after: "EPI-graf + protokolanalyse",
        },
        {
          before: "Mundtlige mål",
          after: "Milepæle med fremskridts­indikator",
        },
        {
          before: "Separat fakturerings­værktøj",
          after: "Lektioner + iDEAL + abonnement i app",
        },
        {
          before: "Mail til ejer om fremskridt",
          after: "Ejeren følger med i egen visning",
        },
      ],
    },
    helper: {
      title: "Hvilken træner app passer til dig?",
      lead: "5 spørgsmål for at se, om et specialiseret coaching­værktøj giver merværdi til din praksis.",
      questions: [
        {
          id: "clients",
          q: "Hvor mange aktive kombinationer coacher du?",
          options: [
            {
              label: "Færre end 5",
              score: 1,
            },
            {
              label: "5-15",
              score: 2,
            },
            {
              label: "Mere end 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "Hvad er din hoved­disciplin?",
          options: [
            {
              label: "Dressur",
              score: 3,
            },
            {
              label: "Spring",
              score: 2,
            },
            {
              label: "Rekreativt / blandet",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "Bruger du video i din coaching?",
          options: [
            {
              label: "Sjældent",
              score: 0,
            },
            {
              label: "Nogle gange (manuelt)",
              score: 2,
            },
            {
              label: "Ofte — struktureret",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "Coacher du stævne­ryttere?",
          options: [
            {
              label: "Nej, rekreativt",
              score: 0,
            },
            {
              label: "Nogle gange stævner",
              score: 2,
            },
            {
              label: "Meget — startkort centralt",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Vil du måle din coaching?",
          options: [
            {
              label: "Nej, intuition er nok",
              score: 0,
            },
            {
              label: "Gerne, men ingen tid",
              score: 2,
            },
            {
              label: "Ja — data­drevet coaching",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Et enkelt værktøj eller endda WhatsApp er nok — for nu.",
          body: "For færre end 5 ryttere uden meget video eller stævner er en coaching­app overkill. EquiSight starter gratis, så du kan prøve det, når din praksis vokser.",
          cta: "Start gratis",
        },
        mid: {
          title: "EquiSight Trainer gør dig strukturelt mere effektiv.",
          body: "Med 5-15 kombinationer mister du hver måned timer på WhatsApp og løse videoer. EquiSight samler alt, scanner protokoller automatisk og sikrer, at ryttere altid kan se deres feedback igen.",
          cta: "Prøv Trainer­modulet",
        },
        high: {
          title: "EquiSight er bygget til din coaching­skala.",
          body: "Mange ryttere, video, stævner og data­drevet coaching: dette er præcis, hvor EquiSight skiller sig ud. EPI + protokolscan + heste­dossier giver dig et forspring, som konkurrenter ikke har.",
          cta: "Planlæg en demo til din coaching­praksis",
        },
      },
    },
    faqTitle: "Ofte stillede spørgsmål om træner apps",
    faq: [
      {
        q: "Hvad er den bedste træner app til hest og rytter?",
        a: "Til ren kommunikation er mange værktøjer tilstrækkelige (endda WhatsApp). Til mål, videoanalyse, protokolscanning, stævnetracking og klient­håndtering i ét værktøj er EquiSight den mest komplette løsning — især fordi det også holder styr på selve hesten, ikke kun kombinationen.",
      },
      {
        q: "Kan EquiSight automatisk læse stævneprotokoller?",
        a: "Ja. Upload et KNHS- eller FEI-protokol, og EquiSight udtrækker scores pr. element, dommerkommentarer og kobler dem til kombinationen. Du ser tendenser på tværs af flere stævner.",
      },
      {
        q: "Hvad er EPI (Equestrian Performance Index)?",
        a: "EPI er en EquiSight-score, der omsætter flere stævneresultater til et sammenligneligt præstations­indeks. Derved ser du reel fremgang på tværs af forskellige klasser og dommere.",
      },
      {
        q: "Kan ryttere selv booke og betale for lektioner?",
        a: "Ja. Ryttere logger ind, ser ledige lektionstider, køber lektionskort og betaler via iDEAL. Du godkender eller tilpasser, hvad du vil tilbyde.",
      },
      {
        q: "Fungerer det også for en instruktør, der arbejder rundt om rideskolen?",
        a: "Ja. Du kan arbejde som freelance­træner med egne klienter uden at tilknytte en rideskole­konto. Klienter betaler dig direkte.",
      },
      {
        q: "Kan jeg migrere eksisterende videoer og noter?",
        a: "Videoer kan du uploade pr. kombination eller via et batch-upload­værktøj. Noter importeres via CSV. Vi hjælper aktive trænere med en engangs­migration.",
      },
    ],
  },
  gidsen: {
    seo: {
      title: "Guider & valghjælp til hestemanagementsoftware | EquiSight",
      description: "Alle EquiSight-guider samlet ét sted: hestemanagementsoftware, avl, rideskole og træner-app-sammenligninger samt valghjælp til 2026.",
      keywords: [
        "hestesoftware guider",
        "hestemanagement valghjælp",
        "avlssoftware sammenligning",
        "rideskole software guide",
        "træner-app sammenligning",
      ],
    },
    hub: {
      eyebrow: "Hub · guider",
      breadcrumbLabel: "Guider",
      title: "Fire komplette guider til at vælge den rigtige hestesoftware.",
      intro: "En dybdegående valghjælp til hver målgruppe: sammenligingstabeller, kriterier, eksempler og interaktiv quiz. Klik videre til den guide, der passer til din situation, eller udforsk de uddybende artikler under hver klynge.",
      stats: {
        guides: "4 valghjælpere",
        articles: "15 uddybende artikler",
        fair: "Ærlig sammenligning",
      },
      readMoreCta: "Læs den komplette guide",
      relatedHeading: "Uddybende artikler",
      articlesCountSingular: "{{count}} uddybende artikel",
      articlesCountPlural: "{{count}} uddybende artikler",
      articlesCountAria: "Antal klynge-artikler",
      lastUpdatedPrefix: "Opdateret",
      lastUpdatedAria: "Dato for seneste opdatering af denne klynge",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Valghjælp til hestemanagement-app",
        blurb: "Sammenlign de mest kendte hestemanagement-apps og find ud af, hvilken der passer til ejer, stald eller avl. Inklusiv ærlig sammenligingstabel og valghjælp med 5 spørgsmål.",
        audience: "Til ejere, staldholdere og alle hestemennesker, der ønsker overblik.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Sammenligning af avlssoftware",
        blurb: "Fra hopcyklus til føludvikling: se hvilken avlssoftware der virkelig fungerer til dit antal hopper, din avlsmetode og studbogens krav.",
        audience: "Til (hobby)avlere, stutterier og hingsteejere.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Valghjælp til rideskolesoftware",
        blurb: "Timeplanlægning, rytterapdministration, ejerportal og fakturering – i ét værktøj. Sammenlign mulighederne for rideskoler og pensionsstalde i 2026.",
        audience: "Til rideskoler, pensionsstalde og ridebedrifter.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Valghjælp til træner-app",
        blurb: "Coaching-CRM, videofeedback, scanning af KNHS-protokol og mål per kombination. Hvilken træner-app passer til din coachingpraksis?",
        audience: "Til instruktører, trænere og coaches.",
      },
    ],
    closing: {
      eyebrow: "Derfor disse guider",
      title: "Ærlig sammenligning – ikke kun priser.",
      body1: "Mange \"sammenligningssider\" er skjulte reklamer. Vores guider opstiller funktioner, målgruppe og konkurrenter side om side, som en uafhængig videnskilde ville gøre det. EquiSight fremstår naturligvis som den komplette løsning, men du kan også læse ærligt, hvor andre apps er stærkere.",
      body2: "De uddybende artikler under hver guide besvarer de konkrete spørgsmål, der opstår i forbindelse med valget: \"Hvornår foretages første scanning efter inseminering\", \"Hvordan automatiserer jeg fakturering for rideskolen\", \"Hvordan analyserer jeg en konkurrenceprotokol\". Ingen marketingsnak – kun praksis.",
    },
    hubName: "EquiSight Guider",
  },
  ui: {
    sectionEyebrows: {
      pains: "Hvorfor det gør ondt",
      basics: "Grundlæggende",
      criteria: "Hvad gør det godt?",
      comparison: "Ærlig sammenligning",
      why: "Forskellen",
      beforeAfter: "Fra fragmentering til overblik",
      helper: "5 spørgsmål",
    },
    table: {
      feature: "Funktion",
      today: "I dag",
      withEquisight: "Med EquiSight",
    },
    helper: {
      questionLabel: "Spørgsmål {{current}} af {{total}}",
      answerPrompt: "Besvar det {{count}} resterende spørgsmål for at se en anbefaling.",
      answerPromptPlural: "Besvar de {{count}} resterende spørgsmål for at se en anbefaling.",
      resultEyebrow: "Dit resultat",
    },
    targetGroupsFallback: "Hvem er dette beregnet til?",
    faqTitleFallback: "Ofte stillede spørgsmål",
  },
};

export default CORNERSTONES;
